// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"2e663ddd","165":"c63c58a9","796":"3848d969"}[chunkId] + ".chunk.js";
};